import React, { useEffect, useState } from "react";
import { User } from "../../types/User";
import GenreLabel from "../genre-label/genre-label";
import "./movie-card.scss";
import {
  deleteRecommendation,
  markMovieAsWatched,
} from "../../firebase/service";
import { HonkMovie } from "../../types/Movie";
import TrashIcon from "../../assets/delete.png";
import { getPosterForMovie } from "../../firebase/moviedb";

type MovieCardProps = {
  movie: HonkMovie;
  currentUser: User;
};

const GenreMap = new Map([
  [0, "HORROR"],
  [1, "ROMCOM"],
]);

const getMovieLink = (movie: HonkMovie) => {
  return "https://www.imdb.com/find?q=" + movie.title;
};

const deleteWithConfirmation = (movie: HonkMovie) => {
  deleteRecommendation(movie);
};

const MovieCard: React.FC<MovieCardProps> = ({ movie, currentUser }) => {
  const [posterUrl, setPosterUrl] = useState<string>();
  useEffect(() => {
    if (movie && movie.poster_path) {
      getPosterForMovie(movie).then((poster) => setPosterUrl(poster));
    }
  }, [movie]);
  return (
    <div className="movie-card-wrapper">
      <div className={"movie-header"}>
        <div className={"title"}>
          {movie.title + ` (${movie.release_date.slice(0, 4)})`}
        </div>
        <input
          title="Watched"
          className={"watched-checkbox"}
          checked={movie.watched}
          onChange={() => markMovieAsWatched(movie)}
          type="checkbox"
        />
        <div className={"genre-labels"}>
          {movie.genre_ids.map((genre) => (
            <GenreLabel key={genre} genre={GenreMap.get(genre)} />
          ))}
        </div>
        <div className={"delete-section"}>
          <img
            onClick={() => deleteWithConfirmation(movie)}
            src={TrashIcon}
            className="delete-icon"
            alt="delete"
          />
        </div>
      </div>
      <div className={"movie-overview-and-poster"}>
        <div className={"movie-overview"}>
          <div className={"movie-description"}>{movie.overview}</div>
          <div className={"movie-imdb-link"}>
            <div className={"imdb-and-rec-by"}>
              <a href={getMovieLink(movie)} className={"link"}>
                IMDB
              </a>
              <div className={"rec"}>Recommended By: {movie.recommendedBy}</div>
            </div>
          </div>
        </div>
        <div className={"movie-poster-wrapper"}>
          <img alt="movie-poster" className={"movie-poster"} src={posterUrl} />
        </div>
      </div>
      <div className={"comment-box"}>
        <div className={"comment-header"}>
          <span className={"recommender"}>{movie.recommendedBy}</span> wrote:
        </div>
        <div className={"comment"}>{movie.comment}</div>
      </div>
    </div>
  );
};
export default MovieCard;
